import styled from "@emotion/styled";
import { ttNormsFontFamily, ttNormsVarFontFamily } from "../../../fonts/fonts";
import { CommonTypeRampProps } from "../types";

export interface TypeRampComponentBaseProps extends Pick<CommonTypeRampProps, "lineClamp"> {
    /**
     * If true, we'll try and select the right variant of the TT Norms font.
     * We don't need this for Inter since it's the default font and this logic should
     * happen somewhere globally in the application.
     */
    includeTTNormsProVarFont?: boolean;
}

// A simple styled component to extend the TypeRamp from.
export const TypeRampComponentBase = styled("span")<TypeRampComponentBaseProps>`
    ${({ lineClamp }) =>
        lineClamp !== undefined
            ? `
                overflow: hidden;
                ${
                    // Because lineClamp tends to be buggy in certain use cases (such as multiple lines
                    // of elided text) We will use the old school ellipsis method for single line
                    // clamping.
                    lineClamp === 1
                        ? `
                            white-space: nowrap;
                            text-overflow: ellipsis;
                        `
                        : `
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: ${lineClamp};
                            line-clamp: ${lineClamp};
                        `
                }
            `
            : ""}

    ${({ includeTTNormsProVarFont }) =>
        includeTTNormsProVarFont
            ? `
                font-family: ${ttNormsFontFamily};

                @supports (font-variation-settings: normal) {
                    font-family: ${ttNormsVarFontFamily};
                }
            `
            : ""}
`;
